"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryCodeToISO2 = void 0;
const tslib_1 = require("tslib");
const country_code_lookup_1 = tslib_1.__importDefault(require("country-code-lookup"));
const countryCodeToISO2 = (countryCode) => {
    const countries = country_code_lookup_1.default.byIso(countryCode);
    return countries ? countries.iso2 : "AU";
};
exports.countryCodeToISO2 = countryCodeToISO2;
//# sourceMappingURL=countryUtils.js.map